import defaultClippingEquation from "./helpers/default-clipping-equation";

class LivelabelConfigs {
    constructor() {
        this.scales = processLabels(DEFAULT_LABEL_SIZES);
    }

    clipEquation(n) { return defaultClippingEquation(n); }
    clip_equation(n) { return this.clipEquation(n); }
};

export default LivelabelConfigs;
export { LivelabelConfigs };

class Scale {
    constructor({ ratio, min_size, size, bound, isMobile, name }) {
        this.ratio = ratio;
        this.min_size = min_size;
        this.size = size;
        this.bound = bound;
        this.isMobile = isMobile;
        this.name = name;

        Object.freeze(this);
    }
}

function processLabels(data) {
    const isMobile = Q3.browserCapabilities.isMobile;
    const scales = {};

    data.forEach((el) => {
        if (isMobile && el.isMobile) {
            scales[el.name] = el;
            if (!el.bound) delete scales[el.name].bound;
        } else if (!isMobile && !el.isMobile) {
            scales[el.name] = el;
            if (!el.bound) delete scales[el.name].bound;
        }
    });

    return Object.freeze(Object.keys(scales).reduce((acc, key) => {
        acc[key] = new Scale(scales[key]);

        return acc;
    }, {}));
}

const DEFAULT_LABEL_SIZES = [{
    bound: 0,
    ratio: 0,
    name: "small",
    min_size: 16,
    size: 30,
    isMobile: false,
}, {
    bound: 0,
    ratio: 0,
    name: "medium",
    min_size: 16,
    size: 30,
    isMobile: false,
}, {
    bound: 0,
    ratio: 0,
    name: "large",
    min_size: 16,
    size: 30,
    isMobile: false,
}, {
    bound: 2,
    ratio: 0.2,
    name: "small",
    isMobile: true,
    min_size: 14,
    size: 48,
}, {
    bound: 2.5,
    ratio: 0.2,
    name: "medium",
    isMobile: true,
    min_size: 14,
    size: 48,
}, {
    bound: 0,
    ratio: 0.2,
    name: "large",
    isMobile: true,
    min_size: 14,
    size: 48,
}];